import React, { useMemo } from 'react';

import { LegacyBox, styled, Tooltip } from '@gogame/components';

const ColorPreview = styled('div')`
  width: 16px;
  height: 16px;
  background: ${(props) => props.hex};
  border-radius: 20%;
`;

const Label = ({ color, name }) => {
  const hex = useMemo(() => {
    let _hex = Number(color).toString(16);
    while (_hex.length < 6) {
      _hex = '0' + _hex;
    }
    return `#${_hex}`;
  }, [color]);

  return (
    <Tooltip title={name}>
      <ColorPreview hex={hex} />
    </Tooltip>
  );
};

const Labels = ({ labels = [] }) => {
  return (
    <LegacyBox vertical={true} gutter={4}>
      {labels.map((label) => (
        <Label key={label.id} {...label} />
      ))}
    </LegacyBox>
  );
};

export default Labels;
